import { isSSR } from "@website/utils/is-ssr";

export const getOrigin = () =>
  isSSR()
    ? process.env.ORIGIN ||
      (process.env.NEXT_PUBLIC_BUILD_ENV === "stage" ||
      process.env.BUILD_ENV === "stage"
        ? "https://stage.snapptrip.com"
        : "https://www.snapptrip.com")
    : window.location.origin;
